import React from "react";
import "./HeroComponentStyles.css";
import SSIlogo from "../../assets/ssi-logo.svg";
import { motion } from "framer-motion";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Link } from "react-scroll";

function HeroComponent() {
  return (
    <Grid container className="hero-component">
      <Grid
        item
        xs={3}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        flexDirection="column"
        className="leftB"
      >
        <motion.div
          initial={{
            opacity: 0,
            translateX: 0,
            translateY: 0,
          }}
          whileInView={{
            opacity: 1,
            // scale: [0.2, 0.4, 0.6, 0.8, 1],
            translateX: 150,
            translateY: -20,
          }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="91"
            height="91"
            viewBox="0 0 91 91"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="45.2913"
              cy="45.1696"
              rx="45.2913"
              ry="45.1696"
              fill="#CD0000"
            />
          </svg>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0,
            translateX: 0,
          }}
          whileInView={{
            opacity: 1,
            // scale: [0.2, 0.4, 0.6, 0.8, 1],
            translateX: -50,
          }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="134"
            height="134"
            viewBox="0 0 134 134"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="66.9001"
              cy="66.7204"
              rx="66.9001"
              ry="66.7204"
              fill="#8B0000"
            />
          </svg>
        </motion.div>

        <motion.div
          className="blackCL"
          initial={{
            translateX: 50,
          }}
          whileInView={{
            scale: [1, 1.2, 1.2, 1, 0.7],
            rotate: [0, 0, 270, 270, 0],
            borderRadius: ["-20%", "-20%", "-50%", "-50%", "-20%"],
          }}
          transition={{
            duration: 2,
            delay: 2,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="90"
            height="90"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="44.9008"
              cy="44.7801"
              rx="44.9008"
              ry="44.7801"
              fill="black"
            />
          </svg>
        </motion.div>
      </Grid>

      <Grid
        item
        xs={6}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <h1 style={{ color: "#8B0000" }}>
          Welcome <span style={{ color: "black" }}>to</span>
        </h1>

        <svg
          initial={{
            opacity: 0,
            translateX: 0,
            translateY: 0,
          }}
          animate={{
            opacity: 1,
            // scale: [0.2, 0.4, 0.6, 0.8, 1],
            translateX: 150,
            translateY: -20,
          }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          drag
          dragConstraints={{
            top: -35,
            left: -65,
            right: 75,
            bottom: 75,
          }}
          width="454"
          height="218"
          viewBox="0 0 494 218"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mainImg"
        >
          <motion.ellipse
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.5 }}
            cx="113.844"
            cy="71.7702"
            rx="57.5689"
            ry="57.4142"
            fill="#CD0000"
          />
          <motion.path
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5 }}
            d="M86.561 109.001C84.2435 107.244 83.6828 105.468 84.8789 103.674L89.1962 97.1702C90.6166 95.0396 92.6911 94.9274 95.4198 96.8338C97.513 98.2916 100.242 99.8054 103.606 101.375C107.007 102.908 110.577 103.674 114.315 103.674C116.931 103.674 119.455 103.375 121.884 102.777C124.314 102.179 126.164 101.02 127.435 99.3008C128.706 97.5814 129.341 95.5442 129.341 93.1893C129.341 91.5073 129.061 90.0308 128.5 88.7599C127.94 87.489 127.024 86.4424 125.753 85.6201C124.482 84.7977 123.174 84.1062 121.828 83.5455C119.473 82.5737 116.502 81.6205 112.913 80.686C109.362 79.7142 105.849 78.5554 102.372 77.2098C99.2699 76.0136 96.429 74.369 93.8499 72.2757C91.2707 70.1825 89.271 67.8276 87.8505 65.2111C86.4301 62.5946 85.7199 59.0996 85.7199 54.7263C85.7199 49.5306 87.402 45.0825 90.7661 41.3819C94.1302 37.6814 97.999 35.3078 102.372 34.2612C106.746 33.2146 111.156 32.6913 115.605 32.6913C120.015 32.6913 124.557 33.3641 129.229 34.7098C133.939 36.0554 137.49 37.7375 139.882 39.7559C142.237 41.737 142.816 43.5312 141.62 45.1385L137.079 51.25C135.546 53.3432 133.49 53.5114 130.911 51.7546C129.267 50.6333 127.005 49.3811 124.127 47.998C121.286 46.615 118.314 45.9235 115.212 45.9235C113.007 45.9235 110.969 46.1104 109.101 46.4842C107.269 46.858 105.643 47.7551 104.223 49.1755C102.802 50.5959 102.092 52.3527 102.092 54.4459C102.092 56.4644 102.615 58.1091 103.662 59.38C104.709 60.6135 105.867 61.5479 107.138 62.1834C108.409 62.7815 109.699 63.2861 111.007 63.6972C115.044 65.0055 118.651 66.1643 121.828 67.1735C125.005 68.1453 127.94 69.2293 130.631 70.4255C134.369 72.1075 137.228 73.7896 139.209 75.4716C141.19 77.1537 142.816 79.4525 144.087 82.3681C145.396 85.2836 146.05 88.7599 146.05 92.7968C146.05 98.7775 144.143 103.73 140.331 107.655C136.518 111.542 132.276 114.047 127.603 115.168C122.968 116.327 118.445 116.906 114.035 116.906C107.531 116.906 102.241 116.271 98.1672 115C94.0929 113.766 90.2241 111.767 86.561 109.001Z"
            fill="#F4F4F4"
          />
          <motion.ellipse
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.5 }}
            cx="252.009"
            cy="71.7702"
            rx="57.5689"
            ry="57.4142"
            fill="#8B0000"
          />
          <motion.path
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5 }}
            d="M224.726 109.001C222.409 107.244 221.848 105.468 223.044 103.674L227.362 97.1702C228.782 95.0396 230.857 94.9274 233.585 96.8338C235.679 98.2916 238.407 99.8054 241.771 101.375C245.173 102.908 248.743 103.674 252.48 103.674C255.097 103.674 257.62 103.375 260.05 102.777C262.479 102.179 264.33 101.02 265.601 99.3008C266.871 97.5814 267.507 95.5442 267.507 93.1893C267.507 91.5073 267.226 90.0308 266.666 88.7599C266.105 87.489 265.189 86.4424 263.918 85.6201C262.648 84.7977 261.339 84.1062 259.994 83.5455C257.639 82.5737 254.667 81.6205 251.079 80.686C247.528 79.7142 244.014 78.5554 240.538 77.2098C237.435 76.0136 234.595 74.369 232.015 72.2757C229.436 70.1825 227.436 67.8276 226.016 65.2111C224.596 62.5946 223.885 59.0996 223.885 54.7263C223.885 49.5306 225.568 45.0825 228.932 41.3819C232.296 37.6814 236.164 35.3078 240.538 34.2612C244.911 33.2146 249.322 32.6913 253.77 32.6913C258.181 32.6913 262.722 33.3641 267.395 34.7098C272.104 36.0554 275.655 37.7375 278.048 39.7559C280.403 41.737 280.982 43.5312 279.786 45.1385L275.244 51.25C273.712 53.3432 271.656 53.5114 269.077 51.7546C267.432 50.6333 265.171 49.3811 262.292 47.998C259.452 46.615 256.48 45.9235 253.378 45.9235C251.172 45.9235 249.135 46.1104 247.266 46.4842C245.434 46.858 243.809 47.7551 242.388 49.1755C240.968 50.5959 240.257 52.3527 240.257 54.4459C240.257 56.4644 240.781 58.1091 241.827 59.38C242.874 60.6135 244.033 61.5479 245.304 62.1834C246.575 62.7815 247.864 63.2861 249.172 63.6972C253.209 65.0055 256.816 66.1643 259.994 67.1735C263.171 68.1453 266.105 69.2293 268.796 70.4255C272.534 72.1075 275.394 73.7896 277.375 75.4716C279.356 77.1537 280.982 79.4525 282.253 82.3681C283.561 85.2836 284.215 88.7599 284.215 92.7968C284.215 98.7775 282.309 103.73 278.496 107.655C274.684 111.542 270.441 114.047 265.769 115.168C261.134 116.327 256.611 116.906 252.2 116.906C245.696 116.906 240.407 116.271 236.333 115C232.258 113.766 228.39 111.767 224.726 109.001Z"
            fill="white"
          />
          <motion.ellipse
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 1.1, 1] }}
            transition={{ duration: 1.5 }}
            cx="390.175"
            cy="71.7702"
            rx="57.5689"
            ry="57.4142"
            fill="black"
          />
          <motion.path
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5 }}
            d="M385.886 115C383.27 115 381.961 113.598 381.961 110.795V38.8028C381.961 35.9994 383.27 34.5976 385.886 34.5976H394.408C397.025 34.5976 398.333 35.9994 398.333 38.8028V110.795C398.333 113.598 397.025 115 394.408 115H385.886Z"
            fill="white"
          />
          <path
            d="M20.595 194.595C19.0251 194.595 18.2402 193.754 18.2402 192.072V148.876C18.2402 147.194 19.0251 146.353 20.595 146.353H49.4591C51.1412 146.353 51.9822 147.082 51.9822 148.54V152.51C51.9822 153.967 51.1412 154.696 49.4591 154.696H28.0634V165.394H47.6762C49.3582 165.394 50.1993 166.123 50.1993 167.581V171.551C50.1993 173.008 49.3582 173.737 47.6762 173.737H28.0634V186.252H50.5357C52.2177 186.252 53.0588 186.981 53.0588 188.438V192.408C53.0588 193.866 52.2177 194.595 50.5357 194.595H20.595ZM63.6557 194.595C62.0858 194.595 61.3008 193.754 61.3008 192.072V148.876C61.3008 147.194 62.0858 146.353 63.6557 146.353H68.6346C70.5634 146.353 72.0211 147.138 73.008 148.708L90.1649 176.26H90.4004C90.2883 174.915 90.2322 173.569 90.2322 172.223V148.876C90.2322 147.194 91.0172 146.353 92.5871 146.353H97.7006C99.2705 146.353 100.055 147.194 100.055 148.876V192.072C100.055 193.754 99.2705 194.595 97.7006 194.595H93.0581C91.1293 194.595 89.6715 193.81 88.6847 192.24L71.1913 164.183H70.9558C71.068 165.529 71.1241 166.874 71.1241 168.22V192.072C71.1241 193.754 70.3391 194.595 68.7692 194.595H63.6557ZM108.331 170.474C108.331 162.737 110.35 156.591 114.387 152.039C118.424 147.486 124.143 145.21 131.544 145.21C136.007 145.21 139.505 145.781 142.04 146.925C144.596 148.069 146.839 149.841 148.768 152.241C149.934 153.698 149.9 154.831 148.667 155.638L144.832 158.128C143.71 158.868 142.511 158.543 141.232 157.152C140.178 156.008 138.844 155.055 137.229 154.293C135.614 153.53 133.831 153.149 131.88 153.149C127.17 153.149 123.817 154.64 121.821 157.623C119.825 160.584 118.827 164.867 118.827 170.474C118.827 176.081 119.825 180.376 121.821 183.359C123.817 186.319 127.17 187.799 131.88 187.799C134.168 187.799 136.141 187.575 137.801 187.126C139.46 186.655 141.03 185.814 142.511 184.603V178.582H135.21C133.528 178.582 132.687 177.853 132.687 176.395V172.425C132.687 170.967 133.528 170.239 135.21 170.239H149.811C151.493 170.239 152.334 170.967 152.334 172.425V189.515C149.194 191.825 146.02 193.44 142.813 194.359C139.629 195.279 135.872 195.739 131.544 195.739C124.255 195.739 118.558 193.462 114.454 188.909C110.372 184.357 108.331 178.211 108.331 170.474ZM163.839 194.595C162.269 194.595 161.484 193.754 161.484 192.072V148.876C161.484 147.194 162.269 146.353 163.839 146.353H168.953C170.522 146.353 171.307 147.194 171.307 148.876V192.072C171.307 193.754 170.522 194.595 168.953 194.595H163.839ZM184.427 194.595C182.858 194.595 182.073 193.754 182.073 192.072V148.876C182.073 147.194 182.858 146.353 184.427 146.353H189.406C191.335 146.353 192.793 147.138 193.78 148.708L210.937 176.26H211.172C211.06 174.915 211.004 173.569 211.004 172.223V148.876C211.004 147.194 211.789 146.353 213.359 146.353H218.472C220.042 146.353 220.827 147.194 220.827 148.876V192.072C220.827 193.754 220.042 194.595 218.472 194.595H213.83C211.901 194.595 210.443 193.81 209.456 192.24L191.963 164.183H191.728C191.84 165.529 191.896 166.874 191.896 168.22V192.072C191.896 193.754 191.111 194.595 189.541 194.595H184.427ZM233.947 194.595C232.377 194.595 231.592 193.754 231.592 192.072V148.876C231.592 147.194 232.377 146.353 233.947 146.353H262.811C264.493 146.353 265.334 147.082 265.334 148.54V152.51C265.334 153.967 264.493 154.696 262.811 154.696H241.416V165.394H261.028C262.71 165.394 263.551 166.123 263.551 167.581V171.551C263.551 173.008 262.71 173.737 261.028 173.737H241.416V186.252H263.888C265.57 186.252 266.411 186.981 266.411 188.438V192.408C266.411 193.866 265.57 194.595 263.888 194.595H233.947ZM277.008 194.595C275.438 194.595 274.653 193.754 274.653 192.072V148.876C274.653 147.194 275.438 146.353 277.008 146.353H305.872C307.554 146.353 308.395 147.082 308.395 148.54V152.51C308.395 153.967 307.554 154.696 305.872 154.696H284.476V165.394H304.089C305.771 165.394 306.612 166.123 306.612 167.581V171.551C306.612 173.008 305.771 173.737 304.089 173.737H284.476V186.252H306.949C308.631 186.252 309.472 186.981 309.472 188.438V192.408C309.472 193.866 308.631 194.595 306.949 194.595H277.008ZM320.069 194.595C318.499 194.595 317.714 193.754 317.714 192.072V148.876C317.714 147.194 318.499 146.353 320.069 146.353H335.644C342.575 146.353 347.632 147.43 350.817 149.583C354.001 151.713 355.594 155.19 355.594 160.012C355.594 163.6 354.304 166.46 351.725 168.59C349.146 170.721 345.871 172.134 341.902 172.829V172.896C344.055 173.704 345.681 174.825 346.78 176.26C347.879 177.696 348.776 178.952 349.471 180.028L356.872 191.702C358.106 193.63 357.679 194.595 355.594 194.595H349.74C348.507 194.595 347.497 193.933 346.712 192.61L339.917 181.273C339.177 180.062 337.82 178.739 335.846 177.303C333.895 175.845 331.955 175.116 330.026 175.116H327.537V192.072C327.537 193.754 326.752 194.595 325.182 194.595H320.069ZM327.537 166.773H333.559C338.044 166.773 341.229 166.269 343.113 165.26C345.019 164.228 345.972 162.602 345.972 160.382C345.972 157.96 345.053 156.39 343.214 155.672C341.397 154.932 338.717 154.562 335.173 154.562H327.537V166.773ZM368.108 194.595C366.538 194.595 365.753 193.754 365.753 192.072V148.876C365.753 147.194 366.538 146.353 368.108 146.353H373.222C374.792 146.353 375.576 147.194 375.576 148.876V192.072C375.576 193.754 374.792 194.595 373.222 194.595H368.108ZM388.697 194.595C387.127 194.595 386.342 193.754 386.342 192.072V148.876C386.342 147.194 387.127 146.353 388.697 146.353H393.675C395.604 146.353 397.062 147.138 398.049 148.708L415.206 176.26H415.441C415.329 174.915 415.273 173.569 415.273 172.223V148.876C415.273 147.194 416.058 146.353 417.628 146.353H422.741C424.311 146.353 425.096 147.194 425.096 148.876V192.072C425.096 193.754 424.311 194.595 422.741 194.595H418.099C416.17 194.595 414.712 193.81 413.726 192.24L396.232 164.183H395.997C396.109 165.529 396.165 166.874 396.165 168.22V192.072C396.165 193.754 395.38 194.595 393.81 194.595H388.697ZM433.372 170.474C433.372 162.737 435.39 156.591 439.427 152.039C443.464 147.486 449.183 145.21 456.584 145.21C461.047 145.21 464.546 145.781 467.08 146.925C469.637 148.069 471.88 149.841 473.809 152.241C474.975 153.698 474.941 154.831 473.708 155.638L469.873 158.128C468.751 158.868 467.551 158.543 466.273 157.152C465.219 156.008 463.885 155.055 462.27 154.293C460.655 153.53 458.872 153.149 456.921 153.149C452.211 153.149 448.858 154.64 446.862 157.623C444.866 160.584 443.868 164.867 443.868 170.474C443.868 176.081 444.866 180.376 446.862 183.359C448.858 186.319 452.211 187.799 456.921 187.799C459.208 187.799 461.182 187.575 462.842 187.126C464.501 186.655 466.071 185.814 467.551 184.603V178.582H460.251C458.569 178.582 457.728 177.853 457.728 176.395V172.425C457.728 170.967 458.569 170.239 460.251 170.239H474.852C476.534 170.239 477.375 170.967 477.375 172.425V189.515C474.235 191.825 471.061 193.44 467.854 194.359C464.669 195.279 460.913 195.739 456.584 195.739C449.295 195.739 443.599 193.462 439.495 188.909C435.413 184.357 433.372 178.211 433.372 170.474Z"
            fill="black"
          />
        </svg>

        <Button
          variant="contained"
          style={{
            borderRadius: 50,
            backgroundColor: "#8B0000",
            margin: 21,
          }}
        >
          <Link to="about" spy={true} smooth={true}>
            Learn More
          </Link>
        </Button>
      </Grid>

      <Grid
        item
        xs={3}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        flexDirection="column"
        className="rightB"
      >
        <motion.div
          initial={{
            translateX: -250,
          }}
          whileInView={{
            scale: [1, 1.2, 1.2, 1, 0.9],
            rotate: [0, 0, 270, 270, 0],
            borderRadius: ["-20%", "-20%", "-50%", "-50%", "-20%"],
          }}
          transition={{
            duration: 1.5,
            delay: 2,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="91"
            height="91"
            viewBox="0 0 91 91"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="45.2913"
              cy="45.1696"
              rx="45.2913"
              ry="45.1696"
              fill="#CD0000"
            />
          </svg>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0,
            translateX: 0,
            translateY: 0,
          }}
          whileInView={{
            opacity: 1,
            translateX: 50,
            translateY: -10,
          }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="90"
            height="90"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="44.9008"
              cy="44.7801"
              rx="44.9008"
              ry="44.7801"
              fill="black"
            />
          </svg>
        </motion.div>
        <motion.div
          initial={{
            opacity: 0,
            translateX: 0,
            translateY: 0,
          }}
          whileInView={{
            opacity: 1,
            translateX: -50,
            translateY: 10,
          }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          drag
          dragConstraints={{
            top: -10,
            left: -10,
            right: 10,
            bottom: 10,
          }}
        >
          <svg
            width="134"
            height="134"
            viewBox="0 0 134 134"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="66.9001"
              cy="66.7204"
              rx="66.9001"
              ry="66.7204"
              fill="#8B0000"
            />
          </svg>
        </motion.div>
      </Grid>
    </Grid>
  );
}

export default HeroComponent;
